import React from "react";
import Datetime from "react-datetime";
import { useTranslation } from "react-i18next";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";

const DOCOnlineWorkExperienceForm = (props) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  function onChangeWorkExperience({ target }, index) {
    let _workExperience = [...props.docOnline.workExperience];
    _workExperience[index][target.name] = target.value;
    props.setDocOnline({
      ...props.docOnline,
      workExperience: _workExperience
    });
  }

  function onChangeStartDate(date, index) {
    let _workExperience = [...props.docOnline.workExperience];
    _workExperience[index]["startDate"] = date._d;
    props.setDocOnline({
      ...props.docOnline,
      workExperience: _workExperience
    });
  }

  function onChangeEndDate(date, index) {
    let _workExperience = [...props.docOnline.workExperience];
    _workExperience[index]["endDate"] = date._d;
    props.setDocOnline({
      ...props.docOnline,
      workExperience: _workExperience
    });
  }

  function onChangeProjectStillGoing(index) {
    let _workExperience = [...props.docOnline.workExperience];
    if (_workExperience[index]["projectStillGoing"] === true) {
      _workExperience[index]["projectStillGoing"] = false;
    } else {
      _workExperience[index]["projectStillGoing"] = true;
    }
    props.setDocOnline({
      ...props.docOnline,
      workExperience: _workExperience
    });
  }

  function getDateValueValid(date) {
    if (date) return new Date(date);
  }

  function isValidEndDate(currentDate) {
    if (props.workExperience.startDate)
      return new Date(props.workExperience.startDate) < currentDate;
    else return true;
  }

  function isValidStartDate(currentDate) {
    if (props.workExperience.endDate)
      return new Date(props.workExperience.endDate) > currentDate;
    else return true;
  }

  return (
    <div className={`work-exp ${props.index > 0 && "separator"}`}>
      <div
        className="form-group position"
        style={{ gridColumn: props.index === 0 ? "span 11" : "1 / 11" }}
      >
        <div className="label-wrapper">
          <label htmlFor="occupationOrPosition">
            {t("Occupation or position held")}
            {props.errors !== undefined &&
              props.errors.workExperience !== undefined &&
              props.errors.workExperience[props.index] !== undefined &&
              props.errors.workExperience[props.index]
                .occupationOrPositionHeld && (
                <span className="error-msg">
                  {
                    props.errors.workExperience[props.index]
                      .occupationOrPositionHeld
                  }
                </span>
              )}
          </label>
        </div>
        <input
          id="occupationOrPositionHeld"
          name="occupationOrPositionHeld"
          type="text"
          onChange={(event) => onChangeWorkExperience(event, props.index)}
          placeholder={t("Title of the occupation")}
          value={props.workExperience.occupationOrPositionHeld}
        />
      </div>
      <div className="form-group company">
        <div className="label-wrapper">
          <label htmlFor="companyEmployerName">
            {t("Company/Employer name")}
            {props.errors !== undefined &&
              props.errors.workExperience !== undefined &&
              props.errors.workExperience[props.index] !== undefined &&
              props.errors.workExperience[props.index].companyOrEmployName && (
                <span className="error-msg">
                  {props.errors.workExperience[props.index].companyOrEmployName}
                </span>
              )}
          </label>
        </div>
        <input
          id="companyOrEmployName"
          name="companyOrEmployName"
          type="text"
          onChange={(event) => onChangeWorkExperience(event, props.index)}
          placeholder={t("E.g. a company, institution or organisation")}
          value={props.workExperience.companyOrEmployName}
        />
      </div>
      <div className="form-group start-date">
        <div className="label-wrapper">
          <label htmlFor="startDate">{t("Start date")}</label>
          {props.errors !== undefined &&
            props.errors.workExperience !== undefined &&
            props.errors.workExperience[props.index] !== undefined &&
            props.errors.workExperience[props.index].startDate && (
              <div className="error-msg">
                {props.errors.workExperience[props.index].startDate}
              </div>
            )}
        </div>
        <Datetime
          id="startDate"
          name="startDate"
          dateFormat="DD-MM-YYYY"
          timeFormat={false}
          utc={true}
          inputProps={{ placeholder: t("dd-mm-yyyy") }}
          onChange={(date) => onChangeStartDate(date, props.index)}
          value={getDateValueValid(props.workExperience.startDate)}
          isValidDate={isValidStartDate}
          locale={i18n.language === "PT" ? "PT" : ( i18n.language === "FR" ? "FR" : "EN")}
        />
      </div>
      <div className="form-group end-date">
        <div className="label-wrapper">
          <label htmlFor="endDate">{t("End Date")}</label>
          {props.errors !== undefined &&
            props.errors.workExperience !== undefined &&
            props.errors.workExperience[props.index] !== undefined &&
            props.errors.workExperience[props.index].endDate && (
              <div className="error-msg">
                {props.errors.workExperience[props.index].endDate}
              </div>
            )}
        </div>
        <Datetime
          id="endDate"
          name="endDate"
          dateFormat="DD-MM-YYYY"
          timeFormat={false}
          utc={true}
          inputProps={{ placeholder: t("dd-mm-yyyy") }}
          onChange={(date) => onChangeEndDate(date, props.index)}
          value={getDateValueValid(props.workExperience.endDate)}
          isValidDate={isValidEndDate}
          locale={i18n.language === "PT" ? "PT" : ( i18n.language === "FR" ? "FR" : "EN")}
        />
      </div>
      <div className="form-group ongoing">
        <div className="label-wrapper">
          <label htmlFor="projectStillGoing">{t("Project still going?")}</label>
        </div>
        <div className="mx-2 form-check form-switch">
          <input
            type="checkbox"
            className="form-check-input"
            id="projectStillGoing"
            name="projectStillGoing"
            onChange={() => onChangeProjectStillGoing(props.index)}
            checked={props.workExperience.projectStillGoing}
          />
        </div>
      </div>
      <div className="form-group activities">
        <div className="label-wrapper">
          <label htmlFor="MainActivities">{t("Main Activities")}</label>
        </div>
        <textarea
          id="mainActivities"
          rows="4"
          name="mainActivities"
          placeholder={t(
            "Main achievements, share the things that you have achieved and make you proud."
          )}
          onChange={(event) => onChangeWorkExperience(event, props.index)}
          value={props.workExperience.mainActivities}
        />
      </div>
      <div className="form-group environment">
        <div className="label-wrapper">
          <label htmlFor="TechnologicalEnvironment">
            {t("Technological Environment")}
          </label>
        </div>
        <textarea
          id="technologicalEnvironment"
          rows="2"
          name="technologicalEnvironment"
          placeholder={t("Describe used technologies, tools and methodologies")}
          onChange={(event) => onChangeWorkExperience(event, props.index)}
          value={props.workExperience.technologicalEnvironment}
        />
      </div>
      {props.index !== 0 && (
        <div className="delete-button-edit">
          <button
            type="button"
            id="deleteWorkExperience"
            onClick={() => props.onDelete(props.index)}
            className="app-button btn-second btn-sm"
          >
            {t("Delete")}
          </button>
        </div>
      )}
    </div>
  );
};

export default DOCOnlineWorkExperienceForm;
